module.exports = __webpack_public_path__ + "static/maven-digital-00-hero-142d176f1b6f567bc126fe642c268572.jpg";